// extracted by mini-css-extract-plugin
export default {"icon":"H1Vl3U","more":"PcDom0","actions":"CrfiSu","small":"rDriQQ","extended":"mCt7fI","fixedHeight":"zu0ltq","actionsTop":"obfK4Q CrfiSu","buttonBorder":"Bb88FA"};